import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthApiService } from '../services/auth-api-service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authApiService: AuthApiService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const token = this.authApiService.getToken();
    const urlsPermitidas = [
      '/consultaUsuario',
      '/actualizaUsuario',
      '/postularUsuario',
      '/solicitudReseteo',
      '/subirImagen',
      '/descargaImagen',
      '/agregaExperiencia',
      '/obtenerExperiencia',
      '/actualizaExperiencia',
      '/agregaEstudios',
      '/obtenerEstudios',
      '/actualizaEstudios',
      '/obtenerPostulaciones',
      '/eliminaEstudios',
      '/eliminaExperiencia',
      '/course/obtener-curso',
      '/course/agregar-curso',
      '/course/eliminar-curso',
      '/course/actualizar-curso',
      '/language/agregaIdioma',
      '/eliminaIdioma',
      '/language/actualizaNivelIdioma',
      '/language/obtenerIdioma'
    ];

    const aplicarIntercepcion = urlsPermitidas.some(url => req.url.includes(url));

    if (!aplicarIntercepcion) {
      // No modificar, solo continuar
      return next.handle(req);
    }

    // Modificar o agregar headers, etc.
    if (token) {
      const cloned = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` }
      });
    /*
      // Verificar si es una petición FormData/multipart
      const isFormData = req.body instanceof FormData;
      const hasMultipartContentType = req.headers.get('Content-Type')?.includes('multipart/form-data');
      
      let cloned: HttpRequest<any>;
      
      if (isFormData || hasMultipartContentType) {
        // Para FormData, usar appendHeaders para preservar el Content-Type automático
        cloned = req.clone({
          headers: req.headers.set('Authorization', `Bearer ${token}`)
        });
      } else {
        // Para otras peticiones, usar setHeaders normalmente
        cloned = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` }
        });
      }*/

      return next.handle(cloned)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.authApiService.logout();
            // Redirige al login si la respuesta es 401
            console.warn('⛔ Usuario no autorizado, redirigiendo al login...');
            this.router.navigate(['/login']);
          }
          return throwError(() => error);
        })
      );
    }

    return next.handle(req);
  }
}
